import { Get_Token } from 'resolvers/Get_Token';
import apiService from './apiService';

export const verifyPhone = async data => {
    const response = await apiService.post('/users/request/verify/number', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const verifyCode = async data => {
    const response = await apiService.post('/users/verify/number', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const createKYC = async data => {
    const response = await apiService.post('/kyc', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const retrieveKYC = async () => {
    const response = await apiService.get('/kyc', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const createPerson = async data => {
    const response = await apiService.get('/kyc/idv/template', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};
